module.exports = __webpack_public_path__ + "static/media/game-icon-record.526286c5.png";